import {
    PRODUCTS_REQUEST,
    PRODUCTS_REQUEST_SUCCESS,
    PRODUCTS_REQUEST_FAIL
} from '../actions/index'

const initialState = {
    loading: false,
    products: null,
    hasMore: true,
    totalProducts: 0,
}

export const getallProductsReducer = (state = initialState, action) => {
    switch (action.type) {
        case PRODUCTS_REQUEST:
            return { ...state, loading: true };
        case PRODUCTS_REQUEST_SUCCESS: {
            const { products, totalProducts, page } = action.payload;
            const updatedProducts = page === 1 ? products : [...(state.products || []), ...products];
            return {
                ...state,
                loading: false,
                products: updatedProducts,
                totalProducts,
                hasMore: updatedProducts.length < totalProducts,
                error: null,
            };
        }
        case PRODUCTS_REQUEST_FAIL:
            return { ...state, loading: false, products: null, error: action.payload };
        default:
            return state;
    }
}